import React from 'react';

const TableLayout = ({ children }) => {
  return (
    <div className="h-[calc(100vh-9rem)] min-h-[400px] overflow-auto">
      {children}
    </div>
  );
};

export default TableLayout;